// extracted by mini-css-extract-plugin
export default {"media-container":"SUz0WK","mediaContainer":"SUz0WK"};